import React from 'react'
import classnames from 'classnames'
import NullDash from './NullDash'

export interface SignedPercentCellProps {
  value: number | null | undefined
  digits?: number
  className?: string
  /** Optional class for the numeric portion (the % stays muted). */
  valueClassName?: string
}

/** Table-friendly signed percent: +/- prefix on the number, muted % suffix. Zero omits sign. */
export const SignedPercentCell: React.FC<SignedPercentCellProps> = ({
  value,
  digits = 1,
  className,
  valueClassName
}) => {
  if (value == null || Number.isNaN(value)) {
    return <NullDash className={className} />
  }
  const scale = 10 ** digits
  const rounded = Math.round(value * scale) / scale
  const normalized = rounded === 0 ? 0 : rounded
  const absText = Math.abs(normalized).toFixed(digits)
  const numText = normalized === 0 ? absText : normalized > 0 ? `+${absText}` : `-${absText}`

  return (
    <span className={classnames('whitespace-nowrap tabular-nums', className)}>
      <span className={valueClassName}>{numText}</span>
      <span className="ml-1 text-xs font-normal text-slate-400 dark:text-slate-400">%</span>
    </span>
  )
}

export default SignedPercentCell
